// Legacy /ev/:page slugs and the /pages/ev/:name record each one opens. Kept
// out of the redirect component so the route loader can use it without
// waiting for the component's chunk.
const EV_PATH_MAP = {
  "bev-basics": "bev-basics",
  "ownership-and-lifecycle": "ownership-and-lifestyle",
  "cost-and-incentives": "cost-and-incentives",
  powertrains: "powertrains",
  resources: "resources",
};

const DEFAULT_PAGE = "bev-basics";

export const evPageName = (page) => EV_PATH_MAP[page] || DEFAULT_PAGE;
